<template>
  <el-container class="up-main">
      <el-aside width="211px">
          <left-menu :active="3"></left-menu>
      </el-aside>
      <el-main class="u-main">
        <r-list></r-list>
      </el-main>
  </el-container>
</template>

<script>
import rList from './components/rList'
import leftMenu from './components/leftMenu'
export default {
  name: "noticeRelease",
  components: {
    rList, leftMenu
  },
  data() {
    return {
      
    }
  },
  created() {
    if(this.$route.query.account){
      sessionStorage.account = this.$route.query.account;
    }
    if(this.$route.query.token){
      sessionStorage.token = this.$route.query.token;
    }    
  },
  methods: {
  }
}
</script>

<style lang="less">
@import '../style.less';
</style>
